export class UserPermissionModel {
  Id: number;
  userId: number;
  moduleId: number;
  permissions: Permission;
}

export enum Permission {
  None=0,
  Access=1,
  View=2
}

export class Module
{
  Id:number;
  Modules:Objects
}

export enum Objects
{
    Building,
    Trench,
    Duct,
    Cable,
    Service,
    Redlining
}
